import { resolveOrgIds } from "./hierarchy-picker";

const FILTER_BY_BY_HIERARCHY = {
  all: "All",
  businessUnit: "Business Unit",
  company: "Company",
  site: "Site",
};

export const resolveDashboardFilterBy = (hierarchy) =>
  FILTER_BY_BY_HIERARCHY[hierarchy] || FILTER_BY_BY_HIERARCHY.all;

export const buildDashboardScopePayload = ({ filters, orgTree }) => {
  const hierarchy = filters?.hierarchy || "all";
  const orgIds = Array.isArray(filters?.orgIds) ? filters.orgIds : [];

  return {
    filterBy: resolveDashboardFilterBy(hierarchy),
    orgIds:
      hierarchy === "country"
        ? resolveOrgIds(orgIds, Array.isArray(orgTree) ? orgTree : [])
        : orgIds,
  };
};
